import { render } from "./CertificateSurgeryRegistration.vue?vue&type=template&id=f8591d14&scoped=true"
import script from "./CertificateSurgeryRegistration.vue?vue&type=script&lang=js"
export * from "./CertificateSurgeryRegistration.vue?vue&type=script&lang=js"

import "./CertificateSurgeryRegistration.vue?vue&type=style&index=0&id=f8591d14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8591d14"]])

export default __exports__